module.exports = __webpack_public_path__ + "media/images/icons/align-center-6903b09b8dfc6f5535020972e2d441bb.svg";